import { render } from "./PasswordRequest.vue?vue&type=template&id=73be6328"
import script from "./PasswordRequest.vue?vue&type=script&lang=js"
export * from "./PasswordRequest.vue?vue&type=script&lang=js"
script.render = render

export default script